import React, { FC } from 'react';
import { PreviewFieldProps } from './PreviewField';
import { RouteLink } from '../RouteLink';

type PickedKeys = 'value' | 'previewUrl' | 'previewUrlTarget';
type PreviewFieldLinkProps = Pick<PreviewFieldProps, PickedKeys> & {
	valueClasses: string;
	forceUseLink: boolean;
};

export const PreviewFieldLink: FC<React.PropsWithChildren<PreviewFieldLinkProps>> = ({
	valueClasses,
	value,
	forceUseLink,
	previewUrl,
	previewUrlTarget,
}) => {
	return (
		<div className={valueClasses}>
			<RouteLink
				href={previewUrl}
				forceUseLink={forceUseLink}
				target={previewUrlTarget}
			>
				{value}
			</RouteLink>
		</div>
	);
};

export default PreviewFieldLink;
